/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { RFCDate } from "../../types/rfcdate.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TUMPeriodDay = {
  /**
   * The UTC day
   */
  date: RFCDate;
  /**
   * Tokens under management consumed on this day
   */
  tokens: number;
};

/** @internal */
export const TUMPeriodDay$inboundSchema: z.ZodMiniType<TUMPeriodDay, unknown> =
  z.object({
    date: z.pipe(z.string(), z.transform(v => new RFCDate(v))),
    tokens: z.int(),
  });

export function tumPeriodDayFromJSON(
  jsonString: string,
): SafeParseResult<TUMPeriodDay, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TUMPeriodDay$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TUMPeriodDay' from JSON`,
  );
}
